<div class="container-fluid top-nav pt-2 app">
  <div class="row">
    <div class="col pl-0 pr-0">
      <div class="card pl-2 pr-2 mt-2 border-0">

        <!-- Header -->
        <div class="row ml-0 mr-0 mb-2 p-2 rounded border-0 bg-secondary align-items-center">
          <div class="col-xl-3 col-lg-4 col-md-6 col">
            <h3 class="h3 mb-0 pl-1 text-truncate lh-33">Notification Automation</h3>
          </div>
          <div class="ml-auto col-xl-4 col-lg-5 col-md-4 col d-none d-md-block text-right">
            <button routerLink="/template-builder" class="btn mr-2">
              <h6 class="btn-text lh-20 pl-3 pr-3">New Template</h6>
            </button>
            <button class="btn">
              <h6 class="btn-text lh-20 pl-3 pr-3">New Automation</h6>
            </button>
          </div>
        </div>

        <!-- Filters bar -->
        <div class="row ml-0 mr-0 mb-3 p-2 rounded border-0 bg-secondary">
          <div class="col-xl-3 col-lg-3 col-md-4 col-12 mb-2 mb-md-0">
            <input class="form-control" placeholder="Search templates" />
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-12 mb-2 mb-md-0">
            <div class="chip-row pt-1">
              <span *ngFor="let status of statusFilters" class="chip">{{ status }}</span>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-5 col-12 mb-2 mb-md-0">
            <div class="chip-row pt-1">
              <span *ngFor="let trigger of triggerFilters" class="chip">{{ trigger }}</span>
            </div>
          </div>
          <div class="col-xl-2 col-lg-2 ml-auto col-md-12 col-12 text-right">
            <button class="btn">
              <h6 class="btn-text lh-20 pl-3 pr-3">AI Assist</h6>
            </button>
          </div>
        </div>

        <!-- Template library -->
        <div class="card p-2 mb-3 bg-secondary">
          <div class="row mb-2">
            <div class="col">
              <h4 class="font-weight-light page-header pt-1 mb-0">Templates</h4>
            </div>
          </div>
          <div *ngFor="let tpl of templates" class="card p-2 mb-2 bg-light item-card">
            <div class="row align-items-center">
              <div class="col-xl-4 col-lg-4 col-md-5 col-12">
                <div class="text-bold">{{ tpl.name }}</div>
                <div class="text-muted small">{{ tpl.taskType }}</div>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-2 col-6">
                <span class="chip chip-status">{{ tpl.status }}</span>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-2 col-6">
                <span class="chip">v{{ tpl.version }}</span>
                <span class="chip">{{ tpl.variants }} variants</span>
              </div>
              <div class="col-xl-1 col-lg-1 col-md-1 col-6">
                <span class="chip" *ngIf="tpl.isSystem">system</span>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-6 text-right">
                <button class="btn btn-sm mr-1">
                  <h6 class="btn-text lh-20 pl-2 pr-2">Edit</h6>
                </button>
                <button class="btn btn-sm mr-1">
                  <h6 class="btn-text lh-20 pl-2 pr-2">Duplicate</h6>
                </button>
                <button class="btn btn-sm">
                  <h6 class="btn-text lh-20 pl-2 pr-2">Preview</h6>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Coverage dashboard -->
        <div class="card p-2 mb-3 bg-secondary">
          <div class="row mb-2 align-items-center">
            <div class="col">
              <h4 class="font-weight-light page-header pt-1 mb-0">Coverage</h4>
            </div>
            <div class="col text-right"><span class="chip">75% configured</span></div>
          </div>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th>
                    <p class="font-weight-bold mb-0">Stage</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Task</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Start</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Stagnation</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Overdue</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of coverage">
                  <td>
                    <p class="mb-0 align-middle lh-27">{{ row.stage }}</p>
                  </td>
                  <td>
                    <p class="mb-0 align-middle lh-27">{{ row.task }}</p>
                  </td>
                  <td><span class="chip" [class.chip-off]="!row.start">{{ row.start ? 'Configured' : 'Missing' }}</span>
                  </td>
                  <td><span class="chip" [class.chip-off]="!row.stagnation">{{ row.stagnation ? 'Configured' : 'Missing'
                      }}</span></td>
                  <td><span class="chip" [class.chip-off]="!row.overdue">{{ row.overdue ? 'Configured' : 'Missing'
                      }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Audit logs -->
        <div class="card p-2 mb-3 bg-secondary">
          <div class="row mb-2 align-items-center">
            <div class="col">
              <h4 class="font-weight-light page-header pt-1 mb-0">Audit</h4>
            </div>
            <div class="col text-right">
              <div class="chip-row">
                <span *ngFor="let status of logsStatusFilters" class="chip">{{ status }}</span>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th>
                    <p class="font-weight-bold mb-0">Sent</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Project</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Task</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Recipient</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Channel</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Template</p>
                  </th>
                  <th>
                    <p class="font-weight-bold mb-0">Status</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of audit">
                  <td>
                    <p class="mb-0 align-middle lh-27">{{ log.sentAt }}</p>
                  </td>
                  <td>
                    <p class="mb-0 align-middle lh-27">{{ log.project }}</p>
                  </td>
                  <td>
                    <p class="mb-0 align-middle lh-27">{{ log.task }}</p>
                  </td>
                  <td>
                    <p class="mb-0 align-middle lh-27">{{ log.recipient }}</p>
                  </td>
                  <td>
                    <p class="mb-0 align-middle lh-27">{{ log.channel }}</p>
                  </td>
                  <td>
                    <p class="mb-0 align-middle lh-27">{{ log.template }} (v{{ log.variant }})</p>
                  </td>
                  <td>
                    <span class="chip" [class.chip-off]="log.status === 'failed'">{{ log.status }}</span>
                    <span class="chip" *ngIf="log.manualOverride">manual</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- AI assist -->
        <div class="card p-2 mb-3 bg-secondary">
          <div class="row mb-2 align-items-center">
            <div class="col">
              <h4 class="font-weight-light page-header pt-1 mb-0">AI Assist</h4>
            </div>
            <div class="col text-right">
              <button class="btn">
                <h6 class="btn-text lh-20 pl-3 pr-3">Generate</h6>
              </button>
            </div>
          </div>
          <div class="row">
            <div *ngFor="let idea of aiSuggestions" class="col-xl-6 col-lg-6 col-md-12 col-12 mb-2">
              <div class="card p-2 bg-light item-card">
                <div class="text-bold mb-1">{{ idea.title }}</div>
                <div class="text-muted small mb-2">{{ idea.summary }}</div>
                <ul class="mb-2">
                  <li *ngFor="let action of idea.actions">{{ action }}</li>
                </ul>
                <button class="btn btn-sm">
                  <h6 class="btn-text lh-20 pl-2 pr-2">Apply</h6>
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>